// extracted by mini-css-extract-plugin
export default {"textWrapper":"Slide_textWrapper__JJM7h","cardTitle":"Slide_cardTitle__MSUuR","goBackBtn":"Slide_goBackBtn__zM3jy","cardText":"Slide_cardText__Im53r"};